import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-item px-3" }
const _hoisted_2 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-50px me-5\"><svg width=\"50px\" height=\"50px\" viewBox=\"0 0 24 24\" version=\"1.1\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect><path d=\"M6,2 L18,2 C19.6568542,2 21,3.34314575 21,5 L21,19 C21,20.6568542 19.6568542,22\r\n                  18,22 L6,22 C4.34314575,22 3,20.6568542 3,19 L3,5 C3,3.34314575 4.34314575,2 6,2 Z M12,11\r\n                  C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7\r\n                  C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 \r\n                  12,11 Z M7.00036205,16.4995035 C6.98863236,16.6619875 7.26484009,17 7.4041679,17 C11.463736,17 14.5228466,17 \r\n                  16.5815,17 C16.9988413,17 17.0053266,16.6221713 16.9988413,16.5 C16.8360465,13.4332455 14.6506758,12 11.9907452,12 \r\n                  C9.36772908,12 7.21569918,13.5165724 7.00036205,16.4995035 Z\" fill=\"#CFCFCF\"></path></g></svg></div>", 1)
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_6 = { class: "fw-bold text-hover-secundary fs-7 text-break" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_8 = { class: "menu-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user?.nome), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.procuraAcesso(_ctx.user.codNivel)), 1)
        ])
      ])
    ]),
    _hoisted_7,
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link text-primario"
      }, " Sair ")
    ])
  ]))
}